import Pagination from '@mui/material/Pagination';
import { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, convertToNumber } from "../CommonComponents/CustomHooks";
import { InputBox } from "../CommonComponents/InputBox";
import { InvoiceCard } from "../CommonComponents/Table";
import { GetSession } from '../CommonComponents/cryptoUtils';

const CancellationRequest = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    const [result, setResult] = useState({ Data: [] });
    const inputrefs = useRef([]);
    const LoginType = GetSession('cookies', 'loginUserType');
    const [Response, setResponse] = useState({});
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);

    const [formData, setFormData] = useState({
        "type": "CancellationOTP",
        "mobileNo": "",
        "onlinePaymentID": "",
        "policyNo": "",
        "otp": ""
    })

    const handleClear = async () => {
        await setFormData({
            "type": "CancellationOTP",
            "onlinePaymentID": "",
            "mobileNo": "",
            "policyNo": "",
            "otp": ""
        })
        await inputrefs.current['txtPolicyNo'].focus()
        setShowOtpInput(false)
        setIsDisabled(false)
        setResponse({})
        setResult({ Data: [] })
    }

    const GetCancellationRequest = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            loginUserType: LoginType,
            "PageIndex": PageIndex.toString(),
        }
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/DealerMaster/GetDataForCancellationRequest', GetData)
        await dispatch(setSubLoading(false))
        await setResult(data)
        if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED' || data.Status === 'ERROR') {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        GetCancellationRequest(value);
    };

    const handleSendOtp = async (id, OnlinePaymentID, policy) => {
        try {
            let data = await ApiCall(`/api/Login/SendOTPToMobileNo`, { ...formData, onlinePaymentID: OnlinePaymentID, policyNo: policy ? policy : '' });
            setResponse(data)
            setFormData(prevData => ({ ...prevData, otp: '', onlinePaymentID: OnlinePaymentID, validate: '' }));
            if (data.status === 'SUCCESS') {
                await setIsModalOpen(true)
                await setTimer(300);
                await setIsDisabled(true);
                setShowOtpInput(true);
            } else if (data.status === 'ERROR') {
                await setIsModalOpen(false)
                setShowOtpInput(false);
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
        }
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/DealerMaster/InsertCancellationRequest`, { ...formData, onlinePaymentID: (formData.onlinePaymentID).toString(), mobileNo: formData.mobileNo || '' })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs);
        if (data.status === 'SUCCESS') {
            formData.onlinePaymentID = data.onlinePaymentID;
            await handleSubmitRefundTransaction();
            await setIsModalOpen(false);
            await setFormData({ ...formData, otp: '' });
        }
    };

    const handleSubmitRefundTransaction = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/SalesEntryAPI/RefundTransaction`, { Type: 'SaleCancellation', OnlinePaymentID: (formData.onlinePaymentID).toString() || '' })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, GetCancellationRequest);

    };
    const countNo = Math.ceil((parseInt(result?.TotalRecord) / parseInt(result?.PageSize)));

    const borderColors = ['#FF5733', '#33FF57', '#3357FF', '#F1C40F', '#8E44AD'];

    useEffect(() => {
        //inputrefs.current['txtPolicyNo'].focus()
        document.title = 'Cancellation Request'
    }, []);

    useEffect(() => {
        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
            setIsModalOpen(false)
        }

        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    return (
        <>{LoginType ==="Admin"?<div>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Cancellation Request'}</h6>
                </div>
                <div className='row'>
                    <div className='col-sm-5'>
                        <div className='card-body'>
                            <InputBox
                                labelclass='form-label fw-bold'
                                label='Policy No'
                                divclassname={'col-md-12 mb-1'}
                                placeholder='Policy No'
                                inputrefs={inputrefs}
                                id='txtPolicyNo'
                                maxLength='30'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtMobileNo'].focus();
                                    };
                                }}
                                value={formData.policyNo}
                                onChange={(e) => setFormData({ ...formData, policyNo: e.target.value })}
                                autoComplete="off"
                            />
                            <InputBox
                                labelclass='form-label fw-bold'
                                label='Mobile No'
                                divclassname={'col-md-12 mb-1'}
                                placeholder='Mobile No'
                                inputrefs={inputrefs}
                                id='txtMobileNo'
                                maxLength='10'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        result?.TotalRecord > 0 ?
                                            inputrefs.current['txtUserCode'].focus() :
                                            inputrefs.current['txtbtn'].focus();
                                    };
                                }}
                                value={formData.mobileNo}
                                onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })}
                                autoComplete="off"
                            />
                            <div className='d-block mt-3 d-md-flex' >
                                <button
                                    ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                                    onClick={GetCancellationRequest}
                                    className="btn btn-rounded btn-primary">
                                    <span className=" text-white me-2">
                                        <i className="fa fa-search"></i>
                                    </span>Search</button>
                                <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                                </span>Reset</button>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-7'>
                        <div className='password-policy-border'>
                            <div className='w-100 py-2 password-policy px-3'>
                                <h6 className="m-0 font-weight-bold text-white">{'Cancellation Steps'}</h6>
                            </div>
                            <div className='p-3'>
                                <div className="form-group change_password px-2">
                                    <ol>
                                        <li className='changepara' >
                                            Please enter the Policy Number or Mobile Number before clicking *Search* .
                                        </li>
                                        <li className='changepara'>
                                            After retrieving the record, please click the cancel button to cancel the policy.
                                        </li>
                                        <li className='changepara'>
                                            Obtain the OTP from the customer and enter it in the OTP field.
                                        </li>
                                        <li className='changepara'>
                                            After entering the OTP, click Submit to confirm the policy cancellation.
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {result?.TotalRecord > 0 ? (
                    <>
                        <div className='card col-md-4 px-2 p-3'>
                            <h6 className='m-0 d-flex gap-2'>
                                <span>{`${result?.TotalRecord !== undefined ? 'Total Records : ' + result?.TotalRecord : (result?.Data?.length ? 'Total Records : ' + result?.Data?.length : 'No Record Found')}`}</span>
                            </h6>
                        </div>
                        {result?.Data?.map((invoice, index) => (
                            <InvoiceCard
                                key={index}
                                invoice={invoice}
                                handleCheck={handleSendOtp}
                                currentPageNo={currentPageNo}
                                result={result}
                                handleChange1={handleChange1}
                                borderColor={borderColors[index % borderColors.length]}
                            />
                        ))}
                        {countNo > 1 ? (
                            <Pagination
                                className='pt-2'
                                count={countNo}
                                variant="outlined"
                                page={currentPageNo}
                                onChange={handleChange1}
                                shape="rounded"
                                color='primary'
                            />
                        ) : null}
                    </>
                ) : (
                    <div className='main-card card border-0'>
                        <h6 className="norecordFound p-4" style={{ fontWeight: "bold" }}>No records found!</h6>
                    </div>
                )}
            </div>
            <Modal show={isModalOpen} style={{ cursor: 'pointer' }} backdrop="static" onHide={() => setIsModalOpen(false)} >
                <Modal.Header closeButton style={{ background: "mintcream" }}>
                    <Modal.Title><h6 className="modal-title d-flex" id="exampleModalLabel">
                        OTP for Policy Cancellation
                    </h6></Modal.Title>
                </Modal.Header >
                <Modal.Body style={{ background: "mintcream", maxHeight: '450px', maxWidth: '700px', padding: '8px' }} className='modal-body table-responsive'>
                    <div className='p-2 px-4 mb-1' >
                        {isDisabled &&
                            <label className={'text-success fs-6'}>{Response.message}</label>
                        }
                        {showOtpInput && (
                            <>
                                <InputBox
                                    id="txtotp"
                                    labelclass='form-label fw-bold mb-0'
                                    label={"Enter 6 Digit OTP"}
                                    divclassname='col-md-12'
                                    inputrefs={inputrefs}
                                    value={formData.otp}
                                    maxLength={6}
                                    onChange={(e) => setFormData({ ...formData, otp: convertToNumber(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                />
                                <p style={{}} className='mt-3 mb-2 d-flex justify-content-center align-items-center'>
                                    Didn't receive an OTP?
                                    <button
                                        type="button"
                                        onClick={handleSendOtp}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#007bff',
                                            fontWeight: 'bold',
                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                            marginLeft: '7px',
                                            opacity: isDisabled ? 0.5 : 1,
                                        }}
                                        disabled={isDisabled}
                                    >
                                        {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                    </button>
                                </p>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ background: "mintcream" }}>
                    <button type="button"
                        onClick={() => handleSubmit()}
                        className="btn btn-rounded btn-sm btn-success"
                    >
                        <span className=" text-warning me-1">
                            <i className="fa fa-save text-white color-success">
                            </i>
                        </span>Submit
                    </button>
                </Modal.Footer>
            </Modal>
        </div> : <div className="thankyou-text mt-5" style={{ fontSize: "25px", textAlign: "center", color: "red" }}>If you wish to cancel the policy, please write to <a href="mailto:feedback@cppindia">feedback@cppindia</a>, from your registered email ID with CPP Membership ID.</div>}
        </>
    )
}
export default CancellationRequest;